import React, { useEffect } from "react";
import { getRolePermissions } from "../../services/roleService";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import { useMsal } from "@azure/msal-react";
import { handleError } from "../../utils/utilFunctions";
import { toast } from "react-toastify";

const RolePermissions = () => {
  const { accounts } = useMsal();
  const setRolePermissions = useRolePermissionsStore(
    (state: any) => state.setRolePermissions,
  );

  useEffect(() => {
    if (accounts.length > 0) {
      const fetchRolePermissions = async () => {
        const response = await getRolePermissions();

        if (response?.status === 200) {
          setRolePermissions(response?.data);
        } else {
          handleError({
            status: response?.status,
            toast,
            errorMessage: "",
            onClose: () => {},
          });
        }
      };

      fetchRolePermissions();
    }
    // eslint-disable-next-line
  }, [accounts]);

  return <></>;
};

export default RolePermissions;
